/** @file Emits skins as [slot, placeholder, attachment] index triples and the default skin index. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Pose2DJson } from '@pose2d/format/types';
import { requireCompiledIndex } from './requireCompiledIndex';

type SkinJson = Pose2DJson['skins'][number];

/** Skins in name order (R12-01), the id -> index map and the default skin's index. */
export function compileSkins(doc: Doc, slotIndex: ReadonlyMap<string, number>, attachmentIndex: ReadonlyMap<string, number>): { skins: Pose2DJson['skins']; skinIndex: Map<string, number>; defaultSkin: number } {
  const entries = entriesByName(doc.skins);
  const skinIndex = new Map(entries.map(([id], i) => [id, i]));
  const skins = entries.map(([id, skin]): SkinJson => ({
    name: skin.name,
    map: skin.entries.map((e, i): [number, string, number] => [
      requireCompiledIndex(slotIndex, e.slot, 'slot', `skins.${id}.entries.${i}.slot`),
      e.placeholder,
      requireCompiledIndex(attachmentIndex, e.attachment, 'attachment', `skins.${id}.entries.${i}.attachment`),
    ]),
  }));
  return { skins, skinIndex, defaultSkin: requireCompiledIndex(skinIndex, doc.defaultSkin, 'skin', 'defaultSkin') };
}
